<template>
	<div id="nav" class="text-white">
		<b-navbar 	id="navbar"
					variant="faded"
					type="light"
					v-b-scrollspy="{ offset: scrollOffset }">
			<b-container class="d-block">
				<b-row class="align-items-center align-items-lg-end pl-1 pl-lg-0">
					<b-col cols="auto">
						<a :href="$creo.getLang() == 'sv'?'https://www.jm.se/om-oss/' : 'https://www.jm.se/en/about-us/'" target="_blank" class="logo">
							<img src="../assets/img/JM_LOGO.png" />
						</a>
					</b-col>
					<b-col class="pl-0 px-lg-0 pb-lg-2 pt-2 pt-lg-0">
						<b-navbar-nav :class="showMenu ? 'show' : ''">
							<b-nav-item :href="'#'+link.route"
										v-scroll-to="{ el: '#'+link.route, offset: -scrollOffset }"
										class="medium font-weight-semi-bold"
										:class="link.extra"
										v-for="(link, mkey) in links"
										@click="toggleMenu()"
										:key="mkey">
									<span class="px-lg-2 px-xl-3" v-if="$creo.getLang() == 'sv'">{{ link.title }}</span>
									<span v-else>{{ link.title }}</span>
							</b-nav-item>
							<a 	:href="$creo.browserPdfLink(pdfLink.org[$creo.getLang()], pdfLink.fallback[$creo.getLang()], pdfLink.page[$creo.getLang()])"
								id="dlDrop"
								target="_blank"
								class="medium font-weight-semi-bold dl d-lg-none nav-item text-decoration-none">
								<div class="nav-link">
									<span class="text-primary" v-if="$creo.getLang() == 'sv'">Ladda ner PDF <img src="../assets/icons/download.svg"></span>
									<span class="text-primary" v-else>Download PDF <img src="../assets/icons/download.svg"></span>
								</div>
							</a>
						</b-navbar-nav>
						<p class="m-0 pb-2 text-black d-lg-none" v-if="$creo.getLang() == 'sv'">Årsredovisning 2020</p>
						<p class="m-0 pb-2 text-black d-lg-none" v-else>Annual Report 2020</p>
					</b-col>
					<b-col cols="auto" class="pt-2 pt-lg-0">
						<a 	:href="$creo.browserPdfLink(pdfLink.org[$creo.getLang()], pdfLink.fallback[$creo.getLang()], pdfLink.page[$creo.getLang()])"
							id="dlDrop"
							target="_blank"
							class="dl-btn d-none d-lg-block">
							<div v-if="$creo.getLang() == 'sv'" class="pdf-dl" />
							<div v-else class="pdf-dl-en" />
						</a>
						<b-btn 	variant="menu"
								@click="toggleMenu()"
								:title="showMenu ? 'Close' : 'Menu'"
								:class="showMenu ? 'open' : ''"
								class="d-lg-none pt-1">
							<span v-if="$creo.getLang() == 'sv'">{{ showMenu ? 'Stäng' : 'Meny' }}</span>
							<span v-else>{{ showMenu ? 'Close' : 'Menu' }}</span>
							<div class="bar">
								<span></span>
								<span></span>
								<span></span>
							</div>
						</b-btn>
					</b-col>
				</b-row>
			</b-container>
		</b-navbar>
	</div>
</template>
<script>
	export default {
		name: 'Navbar',
		props: {
			pdfLink: {
				type: Object,
				default: null
			}
		},
		data() {
			return {
				windowWidth: document.body.clientWidth,
				scrollOffset: 0,
				showMenu: false,
				links: [
					{
						route: 'number',
						title: this.$creo.getLang() == 'sv' ? 'Nyckeltal' : 'Key ratios',
						extra: 'ml-lg-auto'
					},
					{
						route: 'vd',
						title: this.$creo.getLang() == 'sv' ? 'VD-ord' : "CEO's comments",
						extra: ''
					},
					{
						route: 'investering',
						title: this.$creo.getLang() == 'sv' ? 'Investering' : 'Investment',
						extra: ''
					},
					{
						route: 'kunden',
						title: this.$creo.getLang() == 'sv' ? 'Kunden' : 'Customer',
						extra: ''
					},
					{
						route: 'samhallet',
						title: this.$creo.getLang() == 'sv' ? 'Strategi' : 'Strategy',
						extra: ''
					},
					{
						route: 'hallbarhet',
						title: this.$creo.getLang() == 'sv' ? 'Hållbarhet' : 'Sustainability',
						extra: 'mr-lg-auto'
					}
				]
			}
		},
		methods: {
			toggleMenu() {
				if(this.windowWidth < 992) {
					this.showMenu = !this.showMenu
					if(this.showMenu) {
						document.body.classList.add('menuopen')
					} else {
						document.body.classList.remove('menuopen')
					}
				}
			},
			debounce(fn, ms) {
				var time = null
				return function() {
					var a = arguments, t = this
					clearTimeout(time)
					time = setTimeout(function() { fn.apply(t, a); }, ms)
				}
			}
		},
		mounted() {
			setTimeout(function() {
				this.windowWidth = document.body.clientWidth
				this.scrollOffset = document.getElementById('nav').clientHeight
			}.bind(this), 1000)
			window.addEventListener('resize', this.debounce(function() {
				this.scrollOffset = document.getElementById('nav').clientHeight
				this.windowWidth = document.body.clientWidth
				if(this.windowWidth > 991) {
					document.body.classList.remove('menuopen')
					this.showMenu = false
				}
			}.bind(this), 500), false)
		}
	}
</script>
